import React, { createContext, useContext, useEffect } from "react" 
import { Outlet, useParams, useNavigate } from "react-router-dom"
import { Plus } from "lucide-react"
import { useAppCtx, appStore } from "lib/state";
import { queryTools, cn, randoms } from "lib/utils";
import { CollectionLoader, UnitTitleBlock } from "lib/components"
import { Layout } from "." 

const layoutnames = [
  "Nirvana",
  "Pearl Jam",
  "Smashing Pumpkins",
  "Alice in Chains",
  "Nine Inch Nails",
  "Soundgarden",
  "Stone Temple Pilots",
  "Radiohead",
  "Foo Fighters",
  "Weezer",
  "Oasis",
  "Blur"
]


const LayoutContext = createContext({})
export const useLayoutCtx = () => useContext(LayoutContext)

export default function LayoutProvider({ className="" }:{ className?:string }){
  const navigate = useNavigate()
  const { layid } = useParams()
  const { appState } = useAppCtx()
  const { store, AppStore }:any = appStore()
  
  const { data:_Layouts } = queryTools.resource.parseQueryForApi("layout.findAll", {}, {})
  const { data:_Layout } = queryTools.resource.parseQueryForApi("layout.findById", { _id: layid }, { enabled: !!layid })
  const saveFn = queryTools.resource.save(["layout"])
  
  const createLayout = (e:any) => {
    const newName = layoutnames.find(name => !_Layouts.some((l:any) => l.name === name)) || `Layout ${Math.floor(Math.random() * 1000)}`
    const regex = /\s+/gm
    const refstr = newName.replace(regex, "").toLowerCase()
    const data = { name: newName, refstr: refstr, description: "", funfact: "", config: { structure: [] } }
    saveFn.mutate({ resource: "layout", data } )
  }

  return (
    <LayoutContext.Provider value={{ }}>
      <div className={cn("w-full pt-6", className)}>
        <UnitTitleBlock className="left-[10px] w-[calc(100%+10px)]" title="Layout manager">
          <Plus className="size-5 cursor-pointer stroke-1 stroke-gray-100" onClick={createLayout} />
        </UnitTitleBlock>

        <div className="w-full flex items-stretch gap-4">
          
          <div className="w-2/12 flex items-stretch border border-solid border-slate-700 h-[40rem] overflow-auto scrollbar">
            <CollectionLoader 
              collection={_Layouts}
              selectFn={(item:any) => navigate(`/layout/${item._id}`)}
              selectProp="_id"
              labelProp="name"
              className="w-full"
            />
          </div>

          <div className="w-10/12">
            { _Layout !== undefined && ( <Layout key={randoms.string(12, "a#")} id={layid} /> )}
          </div>

        </div>
    
      </div>
    </LayoutContext.Provider>
  )
}